import React from 'react'

const DocumentUploadError = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
            d="M10.9797 2.99844C11.1597 2.63844 11.5797 2.39844 11.9997 2.39844C12.4197 2.39844 12.8397 2.63844 13.0197 2.99844L22.6197 19.7984C22.8597 20.1584 22.8597 20.6384 22.6197 20.9984C22.4397 21.3584 22.0197 21.5984 21.5997 21.5984H2.39971C1.97971 21.5984 1.61971 21.3584 1.37971 20.9984C1.13971 20.6384 1.13971 20.1584 1.37971 19.7984L10.9797 2.99844ZM21.5997 20.3996L11.9997 3.59961L2.39966 20.3996H21.5997ZM12.5397 15.5994C12.6597 14.1594 12.9597 10.1394 12.9597 8.99941V8.39941H11.1597V8.99941C11.1597 10.1394 11.3997 14.1594 11.5797 15.5994H12.5397ZM10.7996 17.9964C10.7996 17.3364 11.2796 16.8564 11.9996 16.8564C12.7196 16.8564 13.1996 17.3364 13.1996 17.9964C13.1996 18.7164 12.7196 19.1964 11.9996 19.1964C11.2796 19.1964 10.7996 18.7164 10.7996 17.9964Z"
            fill="#BF152C"
        />
    </svg>
)

export default DocumentUploadError
